import React, { useEffect } from 'react';
import styled from 'styled-components';
import { yupResolver } from '@hookform/resolvers';
import { useForm } from 'react-hook-form';
import { Button } from '@material-ui/core';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { InputTextWithLabel } from '../../../molecules';
import { BottomControls, ControlRow } from './WikiDetails';
import { RootState } from '../../../redux/root';
import { LinkSchema } from './schema';
import { useAddWikiLinkMutation, useUpdateWikiLinkMutation } from '../../../redux/rtkQuery/apiWikiSlice';
import { objectKeysToSnakeCase } from '../../../utils';
import { setSelectedJurisdiction, setSelectedLink } from '../../../redux/slices/wikiSlice';
import { JuriLinkType } from '../../../api/jurisdiction';

type LinkType = {
  link: string;
  description: string;
};
const AddLinkForm = ({ setShow }) => {
  const { wikiId } = useParams();
  const juri = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const selectedLink = useSelector((s: RootState) => s.wikiSlice.selectedLink);
  const [addWikiLink] = useAddWikiLinkMutation();
  const [updateWikiLink] = useUpdateWikiLinkMutation();
  const dispatch = useDispatch();
  const { register, handleSubmit, getValues, errors, control, formState, reset } = useForm<LinkType>({
    resolver: yupResolver(LinkSchema),
    defaultValues: {} as LinkType,
  });

  useEffect(() => {
    if (selectedLink && Object.keys(selectedLink).length > 0) {
      reset(selectedLink);
    }
  }, [selectedLink]);

  const onSubmit = async data => {
    if (selectedLink && Object.keys(selectedLink).length === 0) {
      const result = await addWikiLink(objectKeysToSnakeCase({ ...data, jurisdiction: wikiId }));
      const _juri = {
        ...juri,
        links: [...juri.links, result.data],
      };
      dispatch(setSelectedJurisdiction(_juri));
    } else {
      // update
      const _result = await updateWikiLink(objectKeysToSnakeCase({ ...data, id: selectedLink.id, jurisdiction: wikiId }));
      const _juri = {
        ...juri,
        links: juri.links.map(l => {
          if (l.id === _result.data.id) {
            return _result.data;
          }
          return l;
        }),
      };
      dispatch(setSelectedJurisdiction(_juri));
    }
    dispatch(setSelectedLink({} as JuriLinkType));
    setShow(false);
  };

  return (
    <Wrapper>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" aria-autocomplete="none">
        <ControlRow>
          <InputTextWithLabel inputRef={register} error={errors.link} isRequired name="link" label="Link" />
        </ControlRow>
        <ControlRow>
          <InputTextWithLabel inputRef={register} error={errors.description} isRequired name="description" label="Description" />
        </ControlRow>
        <ControlRow>
          <BottomControls>
            <Button variant="contained" type="submit" color="primary">
              Save
            </Button>
          </BottomControls>
        </ControlRow>
      </form>
    </Wrapper>
  );
};

export default AddLinkForm;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
